import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  Scale,
  ScaleInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredNumber } from "~/utils/validations";

type Values = {
  howSupported: Scale | undefined;
};

const validationSchema = Yup.object({
  howSupported: requiredNumber,
});

export const HowSupportedPage: FC = () => {
  const { t } = useTranslation();
  const { howSupported } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    howSupported: howSupported || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.howSupportedPage.question")} />

          <ScaleInput
            autoAdvance
            defaultValue={howSupported}
            id="howSupported"
            scalePath="onboarding.howSupportedPage"
          />
        </QuestionContainer>

        <NextButton showButton={!!howSupported} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
